import { useShareCandidateProfileLazyQuery } from "@/features/people/graphql/generated";
import { useToast } from "@/shared/contexts/toast.context";
import { useTranslation } from "react-i18next";

interface ShareProfileParams {
  personId: number;
  projectId: number;
  orgId: number;
}

export const useShareProfile = () => {
  const { showToast } = useToast();
  const { t } = useTranslation();
  const [shareCandidateProfile, { data, loading, error }] =
    useShareCandidateProfileLazyQuery();

  const handleShareProfile = async ({
    personId,
    projectId,
    orgId,
  }: ShareProfileParams) => {
    const { data, loading, error } = await shareCandidateProfile({
      variables: {
        personId: personId,
        projectId: projectId,
        orgId: orgId,
      },
    });

    const sharedProfile: string = data?.shareCandidateProfile || "";
    const link = `${
      import.meta.env.VITE_APP_URL || window.location.origin
    }/${sharedProfile}`;

    // Copy link to clipboard
    navigator.clipboard.writeText(link);

    showToast({
      message: t("profile.link_copied"),
      type: "success",
    });

    return {
      data,
      loading,
      error,
    };
  };

  return {
    handleShareProfile,
    data,
    loading,
    error,
  };
};
